import { atom } from 'recoil';

export const smsMetric = atom({
  key: 'smsMetric', // unique ID (with respect to other atoms/selectors)
  default: 'Total', // default value (aka initial value)
});
